export default __webpack_public_path__ + "static/media/pantalla_pagos_callejeritos_ingles.e7b8965a.png";